import React, { useCallback } from 'react';
import { withStyles } from '@mui/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import SwitchMUI from '@mui/material/Switch';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});

const Switch = React.memo(function Switch({ classes, value, onChange }) {
  // Convert string value to boolean checked state
  const checked = value === 'Y' || value === true;

  const handleChange = useCallback((event) => {
    // Convert boolean back to string value based on the options
    const newValue = event.target.checked ? 'Y' : 'N';
    onChange(newValue);
  }, [onChange]);

  return (
    <div className={classes.root}>
      <SwitchMUI
        checked={checked}
        onChange={handleChange}
        classes={{
          switchBase: classes.iOSSwitchBase,
          checked: classes.iOSChecked,
          bar: classes.iOSBar,
        }}
      />
    </div>
  );
});

export default withStyles(styles)(Switch);